import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { PERSIST_KEYS } from '@app/app/persist/persist-keys';

import type { OnboardingTourState } from './onboarding.types';

interface OnboardingStore {
  /** Dismissed state for each tour */
  tourStates: Record<string, OnboardingTourState>;
  /** Currently active tour id, null if none */
  activeTourId: string | null;

  startTour: (tourId: string) => void;
  dismissTour: (tourId: string) => void;
  stopActiveTour: () => void;
  setTourStates: (states: Record<string, OnboardingTourState>) => void;
  isTourDismissed: (tourId: string) => boolean;
}

export const useOnboardingStore = create<OnboardingStore>()(
  persist(
    (set, get) => ({
      tourStates: {},
      activeTourId: null,

      startTour: (tourId: string) => set({ activeTourId: tourId }),

      dismissTour: (tourId: string) =>
        set((state) => ({
          tourStates: {
            ...state.tourStates,
            [tourId]: { dismissed: true },
          },
          activeTourId: state.activeTourId === tourId ? null : state.activeTourId,
        })),

      stopActiveTour: () => set({ activeTourId: null }),

      setTourStates: (states: Record<string, OnboardingTourState>) => set({ tourStates: states }),

      isTourDismissed: (tourId: string) => {
        return get().tourStates[tourId]?.dismissed ?? false;
      },
    }),
    {
      name: PERSIST_KEYS.ONBOARDING_STATE,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        tourStates: state.tourStates,
      }),
    },
  ),
);
